module.exports = __webpack_public_path__ + "img/lb_lbsq.d6eddbd7.svg";